import React from 'react';
import ReactDOM from 'react-dom';
import App from './containers/App/App';
import * as serviceWorker from './serviceWorker';

/*
 * TEMPORARY diagnostic for the "hover/click on ticket tiles takes several
 * seconds to respond" investigation. Opt-in via ?debugPerf=1 so it never
 * affects normal users. Logs:
 *  - "longtask": any JS task that blocks the main thread >50ms, with when
 *    it started and how long it ran.
 *  - "event": the real end-to-end latency of an input event (hover/click/etc),
 *    split into delay-before-processing vs actual-handler-processing-time.
 * Remove this block (and the ?debugPerf=1 param) once the cause is found.
 */
if (typeof window !== 'undefined' && window.location.search.includes('debugPerf')) {
  try {
    new PerformanceObserver((list) => {
      list.getEntries().forEach((entry) => {
        console.warn(
          `[perf] LONG TASK: ${entry.duration.toFixed(0)}ms, started at ${entry.startTime.toFixed(0)}ms since nav`,
          entry
        );
      });
    }).observe({ type: 'longtask', buffered: true });
  } catch (e) {
    console.warn('[perf] longtask observer unsupported', e);
  }

  try {
    new PerformanceObserver((list) => {
      list.getEntries().forEach((entry) => {
        console.warn(
          `[perf] SLOW "${entry.name}" EVENT: total ${entry.duration.toFixed(0)}ms ` +
          `(waited ${(entry.processingStart - entry.startTime).toFixed(0)}ms before handling, ` +
          `handler ran ${(entry.processingEnd - entry.processingStart).toFixed(0)}ms)`,
          entry
        );
      });
    }).observe({ type: 'event', durationThreshold: 16, buffered: true });
  } catch (e) {
    console.warn('[perf] event timing observer unsupported', e);
  }
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
